import { useDispatch } from 'react-redux';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import loadSignedInContext from '@/redux/actions/sessionActions/loadSignedInContext.js';
import { resetPassword } from '@/redux/requests/sessionRequests.js';
import AuthLayout from '../components/AuthLayout.jsx';
import AuthNotice from '../components/AuthNotice.jsx';
import NewPasswordForm from '../components/NewPasswordForm.jsx';
import describeAuthFailure from '../lib/describeAuthFailure.js';

/** Sets a new password from the emailed link, signs the person in and signs out their other sessions. */
const ResetPasswordPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';

  const handleSubmit = async ({ password }) => {
    const res = await resetPassword({ token, password });

    if (res?.success === false) {
      return describeAuthFailure(res);
    }

    await dispatch(loadSignedInContext());
    navigate('/', { replace: true });
    return null;
  };

  return (
    <AuthLayout
      title="Choose a new password"
      description="Every other device signed in to this account is signed out when you save."
      footer={
        <Link className="auth-link" to="/forgot-password">
          Ask for a new link
        </Link>
      }>
      {token ? <NewPasswordForm submitLabel="Save password and sign in" onSubmit={handleSubmit} /> : <AuthNotice>This link is missing its code. Open the link from the email again, or ask for a new one.</AuthNotice>}
    </AuthLayout>
  );
};

export default ResetPasswordPage;
